import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-flowpay-intro',
  templateUrl: './flowpay-intro.component.html',
  styleUrls: ['./flowpay-intro.component.scss'],
})
export class FlowpayIntroComponent implements OnInit {
  creditCardLogo
  public getAltText =
    this.translate.currentLang === 'th' ? 'บริการรับชำระด้วยบัตรเครดิตออนไลน์' : 'Online Credit Card Payment Service'

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {
    this.creditCardLogo = {
      visa: '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/visa-logo.png" width="auto" height="20" alt="visa-logo">',
      mastercard:
        '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/master-card-logo.png" width="auto" height="20" alt="visa-logo">',
      unionpay:
        '<img class="mt-minus-5" src="https://flowaccountcdn.com/new_landing/icon/jcb-logo.png" width="auto" height="20" alt="visa-logo">',
      promptpay:
        '<img class="mt-minus-5" src="https://flowaccountcdn.com/images/payment/Promptpay.png" width="auto" height="20" alt="visa-logo">',
    }
  }
}
